import { Injectable } from '@angular/core';
import {
  CanActivate,
} from '@angular/router';
import { UserService } from './user.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SupportAuthGuard implements CanActivate {


  constructor(private userService: UserService) {
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.userService.hasSupportViewPermission();
  }

}
